import React, { useContext, useEffect } from 'react';
import './App.css';
import CardsDisplay from './components/CardsDisplay';
import Flashcard from './components/FlashcardEditor';
import { ThemeContextProvider, ThemeContext } from './context/ThemeContext';
import FolderManager from './components/FolderManager';
import Dash from './components/Dash';
import MiniDrawer from './components/Drawer';
import App1 from './App1';
import FillInTheBlanks from './FillInTheBlanks';
import SingleLine from './SingleLine';
import TreeView from './components/TreeView';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import TableComponent from './components/TableComponent';
import Login from './components/Login';
import Signup from './components/Signup';
import ResetPassword from './components/ResetPassword';
import ProfilePage from './components/ProfilePage';
import EnhancedEditor from './components/EnhancedEditor';
import PracticeCard from './components/PracticeCard';
import McqCard from './components/McqCard';
import FolderHierarchyPage from './components/FolderHierarchyPage';
import McqSpaced from './components/McqSpaced';
import Dashboard from './components/Dashboard';
import QuizPractice from "./components/QuizPractice";
import McqQuiz from './components/mcqQUIZ';
import TFQuiz from './components/TFQuiz';
import FIBQuiz from './components/FIBQuiz';
import AllQuiz from './components/AllQuiz';
import PracticePage from './components/PracticePage';
import FlashPractice from './components/FlashPractice';
import AllFlash from './components/AllFlash';
import ControlPanel from './components/ControlPanel';
import CreatePasswordPage from './components/Panels/CreatePasswordPage';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import ThemeSettings from './components/ThemeSettings';
import Backup from './components/Backup';
import CustomThemePicker from "./components/CustomThemePicker";
import PrivacyPolicy from './components/PrivacyPolicy';
import ProtectedRoute from './components/ProtectedRoute';
import CreateQuiz from './components/CreateQuiz';

function App() {
  return (
    <ThemeContextProvider>
      <style>{`
        button:focus {
          outline: none !important;
          box-shadow: none !important;
        }
      `}</style>

      <div className="App">
        <Router>
          <DndProvider backend={HTML5Backend}>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route
                path="/password-reset-confirm/:uidb64/:token/"
                element={<ResetPassword />}
              />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />

              {/* Protected Routes */}
              <Route
                path="/home"
                element={
                  <ProtectedRoute>
                    <MiniDrawer content={<Dashboard />} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profilepage"
                element={
                  <ProtectedRoute>
                    <MiniDrawer content={<ProfilePage />} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cards/:subfolder_id"
                element={
                  <ProtectedRoute>
                    <MiniDrawer content={<Flashcard />} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/allquiz"
                element={
                  <ProtectedRoute>
                    <MiniDrawer content={<AllQuiz />} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create-quiz"
                element={
                  <ProtectedRoute>
                    <MiniDrawer content={<CreateQuiz />} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/control-panel"
                element={
                  <ProtectedRoute>
                    <MiniDrawer content={<ControlPanel />} />
                  </ProtectedRoute>
                }
              />
              <Route path="/create-password/:uid/:token" element={<CreatePasswordPage  />} />
              <Route
                path="/practice/:folderId"
                element={
                  <ProtectedRoute>
                    <PracticePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/practiceflashcard/:folderId"
                element={
                  <ProtectedRoute>
                    <AllFlash />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/flashpractice"
                element={
                  <ProtectedRoute>
                    <MiniDrawer content={<FlashPractice />} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/backup"
                element={
                  <ProtectedRoute>
                    <MiniDrawer content={<Backup />} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/custom-theme"
                element={
                  <ProtectedRoute>
                    <MiniDrawer content={<CustomThemePicker />} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/practiceflashcard/:subfolder_id"
                element={
                  <ProtectedRoute>
                    <CardsDisplay />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/allflash"
                element={
                  <ProtectedRoute>
                    <AllFlash />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/practiceparticularcard/:subfolder_id/:text"
                element={
                  <ProtectedRoute>
                    <PracticeCard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/practiceparticularcard/:subfolder_id/mcqs"
                element={
                  <ProtectedRoute>
                    <McqCard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/practicemcqspaced/:subfolder_id/mcqs"
                element={
                  <ProtectedRoute>
                    <McqSpaced />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mcqQUIZ/:subfolder_id/:question_type"
                element={
                  <ProtectedRoute>
                    <McqQuiz />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/practicequiz/:subfolder_id/:question_type"
                element={
                  <ProtectedRoute>
                    <QuizPractice />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/quizpractice/:subfolder_id/:question_type"
                element={
                  <ProtectedRoute>
                    <TFQuiz />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/fibquiz/:subfolder_id/:question_type"
                element={
                  <ProtectedRoute>
                    <FIBQuiz />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </DndProvider>
        </Router>
      </div>
    </ThemeContextProvider>
  );
}

export default App;